import React from 'react';
import { Modal } from 'antd';
import { useModalStore } from '../store/core/modalStore';
import ModalUtil from '../store/core/modalUtil';


interface ModalContentProps {
    content: React.ReactNode;
    title?: string;
    width?: string;
    footer?: React.ReactNode;
}

const getViewportWidth = () => (typeof window !== 'undefined' ? window.innerWidth : 1366);

const getResponsiveModalWidth = (requestedWidth?: string) => {
    const viewportWidth = getViewportWidth();

    if (viewportWidth <= 768) {
        const comfortableWidth = Math.min(viewportWidth - 16, 720);
        return `${comfortableWidth}px`;
    }

    if (viewportWidth <= 1200) {
        const comfortableWidth = Math.min(viewportWidth - 28, 980);
        return `${comfortableWidth}px`;
    }

    return requestedWidth || 'auto';
};

const getModalTop = () => {
    const viewportWidth = getViewportWidth();
    if (viewportWidth <= 768) return 8;
    if (viewportWidth <= 1200) return 12;
    return 20;
};

const getModalBodyPadding = () => {
    const viewportWidth = getViewportWidth();
    if (viewportWidth <= 768) return '12px';
    if (viewportWidth <= 1200) return '16px';
    return '20px';
};

const getModalBodyMaxHeight = () => {
    const viewportWidth = getViewportWidth();
    if (viewportWidth <= 768) return 'calc(100vh - 150px)';
    if (viewportWidth <= 1200) return 'calc(100vh - 145px)';
    return 'calc(100vh - 130px)';
};

const ModalComponent = () => {
    const { modals } = useModalStore();
    const onCloseButtonClick = (e: any) => {
        ModalUtil.closeModal(e, '');
    };

    return (
        <>
            {modals.map((modalContent: ModalContentProps, index: number) => {
                return (
                    <Modal
                        key={index}
                        open={true}
                        onCancel={onCloseButtonClick}
                        width={getResponsiveModalWidth(modalContent.width)}
                        rootClassName="app-modal"
                        title={modalContent.title}
                        footer={modalContent.footer || null}
                        style={{
                            top: getModalTop(),

                        }}
                        styles={{
                            body: {
                                padding: getModalBodyPadding(),
                                maxHeight: getModalBodyMaxHeight(),
                                overflow: 'auto',
                            }
                        }}
                    >
                        <div>{modalContent.content}</div>
                    </Modal>
                );
            })}
        </>
    );
};

export { ModalComponent };
